import { ExperienceRequestEvent } from '@/services/analytics/events/experience-request-event';
import { PageParameters } from '@/services/analytics/models';
import { AnalyticsEventType } from '../models';
import { AppState } from '@/store';
import { Store } from 'vuex';
import { ServicesContainer } from '@/services';
import { TargetDecisionScope } from '@/models/adobe-target';
import { Routes } from '@/router';
import { HOME_PAGE_DECISION_SCOPES, MEAL_BUILDER_DECISION_SCOPES } from '../constants';
import { buildTargetPageParameters } from '../helpers';

export class AdobeExperienceRequestEvent {
  event = AnalyticsEventType.ExperienceRequest;
  targetPageParameters?: PageParameters;
  targetDecisionScope?: TargetDecisionScope[];
  
  constructor(event: ExperienceRequestEvent, store: Store<AppState>, services: ServicesContainer) {
    this.targetPageParameters = buildTargetPageParameters(store, services, event.viewName);
    this.targetDecisionScope = this.getDecisionScopes(event);
  }

  getDecisionScopes(event: ExperienceRequestEvent): TargetDecisionScope[] {
    let decisionScopes: TargetDecisionScope[];

    switch(event.viewName) {
      case Routes.MealBuilder:
        decisionScopes = MEAL_BUILDER_DECISION_SCOPES;
        break;
      case Routes.Home: 
      case Routes.Order:
        decisionScopes = HOME_PAGE_DECISION_SCOPES;
        break;
      default:
        decisionScopes = [];
    }

    if (event.decisionScopes) {
      decisionScopes = [...decisionScopes, ...event.decisionScopes];
    }

    return decisionScopes;
  }
}
